import './index.scss'
import Swiper from 'swiper/swiper-bundle.min.js'
import '../../assets/scripts/number.js'
import '../../assets/scripts/jquery.lettering.js'
import '../../assets/scripts/jquery.textillate.js'

// 首页轮播
var banner = new Swiper('.banner .swiper-container', {
	autoplay: {
        delay: 5000,
        disableOnInteraction: false,
	},
	speed:1000,
	loop:true,//必须
	pagination: {
    el: ".banner .swiper-pagination",
    clickable: true,
  },
}); 

var swiper = new Swiper(".section1 .swiper", {
    slidesPerView: 6,
    spaceBetween: '1.5625%',
    loop:true,
    speed:4000,//匀速时间
    autoplay: {
      delay: 0,
      stopOnLastSlide: false,
      disableOnInteraction: false,
    },
    breakpoints: {
      1366: {  //当屏幕宽度小于等于1280
        slidesPerView: 6,
        spaceBetween: '1.5625%',
      },
      768: {  //当屏幕宽度小于等于768
        slidesPerView: 4,
        spaceBetween: '1.5625%',
      },
      320: {  //当屏幕宽度小于等于320 
        slidesPerView: 2,
        spaceBetween: '1.5625%',
      }
    } 
});


$(".product-nav a").eq(0).addClass("active");
$(".product-list ul").eq(0).addClass("active");
$(".product-nav a").hover(function() {
  let index = $(this).index();
  $(this).addClass("active").siblings().removeClass("active");
  $(".product-list ul").eq(index).addClass("active").siblings().removeClass("active");
})

$(".case-nav a").eq(0).addClass("active");
$(".section3 .pic img").eq(0).addClass("active");
$(".section3 .text .section-title").eq(0).addClass("active");
$(".case-nav a").hover(function() {
  let index = $(this).index();
  $(this).addClass("active").siblings().removeClass("active");
  $(".section3 .pic img").eq(index).addClass("active").siblings().removeClass("active");
  $(".section3 .text .section-title").eq(index).addClass("active").siblings().removeClass("active");
})
